import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { createSelector } from 'reselect';
import usePersistStoreData from '../Hooks/usePersistStoreData';
import LogOutModal from '../Modals/LogOutModal';
import classnames from "classnames";

const ProfileDropdown = () => {
    const [showModal, setShowModal] = useState(false);

    const onCloseClick = () => {
       
        setShowModal(false);
      };

    const {userData} = usePersistStoreData();
    // console.log("userData",userData)
  
    const profiledropdownData = createSelector(
        (state) => state.Profile,
        (user) => user.user
      );
    // Inside your component
    const user = useSelector(profiledropdownData);


    const [userName, setUserName] = useState("Admin");
    const [imgError, setImgError] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem("authUser")) {
            const obj = JSON.parse(sessionStorage.getItem("authUser"));
            setUserName(process.env.REACT_APP_DEFAULTAUTH === "fake" ? obj.username === undefined ? user.first_name ? user.first_name : obj.data.first_name : "Admin" || "Admin" :
                process.env.REACT_APP_DEFAULTAUTH === "firebase" ? obj.email && obj.email : "Admin"
            );
        }
    }, [userName, user]);

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        {userData?.profile_image  && !imgError ? (
                            <>
                            <div className=''
                            style={{
                                width: "2.5rem", // adjust as needed to match icon size
                                height: "2.5rem",
                                borderRadius: "50%", // makes it circular
                                overflow: "hidden",  // hides overflow if image is larger
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            >
                           <img src={userData?.profile_image} alt='profile' 
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover"
                              }}
                              onError={() => setImgError(true)}
                           />
                           </div>
                           </>
                        ):(
                            <i className="mdi mdi-account-circle text-muted  align-middle "
                            style={{
                                fontSize:"2rem"
                            }}
                            ></i>
                            
                        )}
                   
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userData?.name}</span>
                            {/* <div className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text"><div className='d-flex gap-1 align-items-center justify-content-start'>
                                <div className='bg-gl-success rounded-circle' style={{width:'6px',height:'6px'}}></div><span className='text-success'>Online</span></div>
                                </div> */}
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {userData?.name}!</h6>
                   <DropdownItem className='p-0'>
                        <Link to= "/profile" className="dropdown-item">
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Profile</span>
                        </Link>
                    </DropdownItem>
                     {/* <DropdownItem className='p-0'>
                        <Link to= "/apps-chat" className="dropdown-item">
                            <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle">Messages</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to="#" className="dropdown-item">
                            <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle">Taskboard</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to= "/pages-faqs" className="dropdown-item">
                            <i
                                className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle">Help</span>
                        </Link>
                    </DropdownItem>
                    <div className="dropdown-divider"></div>
                    <DropdownItem className='p-0'>
                        <Link to= "/pages-profile" className="dropdown-item">
                            <i
                                className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle">Balance : <b>$5971.67</b></span>
                        </Link>
                    </DropdownItem >
                    <DropdownItem className='p-0'>
                        <Link to= "/pages-profile-settings" className="dropdown-item">
                            <span
                                className="badge bg-success-subtle text-success mt-1 float-end">New</span><i
                                    className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> <span
                                        className="align-middle">Settings</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to= "/auth-lockscreen-basic" className="dropdown-item">
                            <i
                                className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Lock screen</span>
                        </Link>
                    </DropdownItem> */}
                    <DropdownItem className='p-0 ' onClick={() => setShowModal(true)}>
                        <span className="dropdown-item">
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle" data-key="t-logout">Logout</span>
                        </span>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
            {showModal && (
        <LogOutModal
          showModal={showModal}
          onCloseClick={onCloseClick}
        />
      )}
        </React.Fragment>
    );
};

export default ProfileDropdown;